<template>
  <v-sheet>
    <v-dialog
      v-model="isModalVisibleBookmark"
      max-width="500px"
    >
      <bookmark-form />
    </v-dialog>

    <v-dialog
      v-model="confirmCancelBookmark"
      max-width="350"
    >
      <bookmark-cancel />
    </v-dialog>

    <v-dialog
      v-model="promptDeleteBookmark"
      max-width="450"
    >
      <bookmark-delete />
    </v-dialog>

    <v-dialog
      v-model="denyDeleteBookmark"
      max-width="350"
    >
      <bookmark-deny />
    </v-dialog>
  </v-sheet>
</template>

<script>
import BookmarkMixin from 'src/tools/store/utils/bookmarks-mixin'

export default {
  name: 'BookmarkModals',
  components: {
    BookmarkCancel: () => import('src/bookmark/components/BookmarkCancel'),
    BookmarkDelete: () => import('src/bookmark/components/BookmarkDelete'),
    BookmarkDeny: () => import('src/bookmark/components/BookmarkDeny'),
    BookmarkForm: () => import('src/bookmark/components/BookmarkForm'),
  },
  mixins: [
    BookmarkMixin,
  ],
}
</script>
